export default {
  'menu.welcome': 'Welcome',

  'menu.home': 'Home',
  'menu.home.accountInfo': 'Account Info',
  'menu.home.notification': 'Notification',
  'menu.home.password': 'Password',
  'menu.home.country': 'Monetary Symbol',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register.result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',

  'menu.commodityManagement': 'Goods Management',
  'menu.commodityManagement.commodityList': 'Goods List',
  'menu.commodityManagement.commodityAdd': 'Add',
  'menu.commodityManagement.commodityPrice': 'Price Management',
  'menu.commodityManagement.itemLib': 'Goods Library',
  'menu.commodityManagement.itemLibApply': 'Application of Receiving',
  'menu.commodityManagement.priceRule': 'Price Rule',
  'menu.commodityManagement.goodsMultiPackagingAudit': 'Multi-Packaging Audit',

  'menu.transactionManagement': 'Transaction Management',
  'menu.transactionManagement.order': 'Order List',
  'menu.transactionManagement.abnormalOrder': 'Abnormal Order List',
  'menu.transactionManagement.transactionBillPartitioned': 'Transaction Order',
  'menu.transactionManagement.orderDetail': 'Order Details',
  'menu.transactionManagement.orderDetailAlipay': 'Details',
  'menu.transactionManagement.agentOrderStatistic': 'Order Statistic',
  'menu.transactionManagement.refundOrder': 'Refund Management',
  'menu.transactionManagement.repOrder': 'Recover Management',
  'menu.transactionManagement.refundOrderDetail': 'Refund Details',
  'menu.transactionManagement.wechatCCOrder': 'Wechat Complaint',

  'menu.equipmentManagement': 'Equipment',
  'menu.equipmentManagement.deviceList': 'Machine List',
  'menu.equipmentManagement.deviceByServer': 'Machine List',
  'menu.equipmentManagement.atlas': '识别记录',
  'menu.equipmentManagement.details': '设备详情',
  'menu.equipmentManagement.adBank': '广告素材库',
  'menu.equipmentManagement.deviceType': '设备类别',
  'menu.equipmentManagement.deviceListUpdateApp': '设备管理',
  'menu.equipmentManagement.deviceTypeTemplate': '设备类型模板',
  'menu.equipmentManagement.advertisingManagement': '广告管理',
  'menu.equipmentManagement.deviceModel': '设备模型',
  'menu.equipmentManagement.outstock': 'Out Stock List',
  'menu.equipmentManagement.deviceInventory': 'Inventory of Equipment Products',
  'menu.equipmentManagement.groupLine': 'Line Management',
  'menu.equipmentManagement.groupLinePoint': 'Point Management',
  'menu.equipmentManagement.firmware': '固件管理',
  'menu.equipmentManagement.deviceSalesRank': '设备销售排行', // TODO: PUT OFF
  'menu.equipmentManagement.deviceQrCodeManagement': '设备二维码管理',

  'menu.serverControl': 'Operator Management',
  'menu.serverControl.control': 'Operator Management',
  'menu.serverControl.dealer_control': 'Dealer Management',
  'menu.serverControl.after_sale_staff_control': 'After-sales Personnel',
  'menu.serverControl.Daily': 'Operator Daily',
  'menu.serverControl.aliFranchisee': '直付通进件',
  'menu.serverControl.merchant_review': 'Merchant Info Audit',

  'menu.simControl': 'IoT SIM Card',
  'menu.simControl.simCardList': 'SIM Card List',
  'menu.simControl.simFlowLimit': 'Data Plan Management',
  'menu.simControl.simLogoutLog': 'Cancellation Records',
};
